import { render, staticRenderFns } from "./EditDraftContract.vue?vue&type=template&id=c19006f6"
import script from "./EditDraftContract.vue?vue&type=script&lang=js"
export * from "./EditDraftContract.vue?vue&type=script&lang=js"
import style0 from "./EditDraftContract.vue?vue&type=style&index=0&id=c19006f6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports